import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazySatuan = Loadable({
    loader: () => import("pages/Satuan/index"),
    loading: () => <PageLoader />,
});


function SatuanRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazySatuan />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default SatuanRoute;
